import React, { useEffect, useState } from "react";
import SectionHeading from "../../common/headings/SectionHeading";
import { UrlProvider } from "../../../utils/UrlProvider";
import PropTypes from "prop-types";

const Header = ({ headingData }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const componentPosition =
        document.getElementById("listing-testimonial").offsetTop;
      const componentHeight =
        document.getElementById("listing-testimonial").offsetHeight;

      // Check if the component is in the viewport
      if (
        scrollPosition + window.innerHeight > componentPosition &&
        scrollPosition < componentPosition + componentHeight
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    headingData && (
      <div id="listing-testimonial" className="md:text-center  xs:w-[80%] xs:m-auto min-h-[12vw] md:min-h-[6vw]">
        <div className="md:inline-block md:gap-3">
          <SectionHeading
            lable={headingData?.heading}
            lable_color={headingData?.heading_color}
          />
        </div>

        <img
          src={UrlProvider(headingData?.heading_watermark?.url)}
          alt={headingData?.heading_watermark?.alternativeText}
          className={`md:inline-block xs:ml-[66vw] md:mt-[-3vh] mt-[-10vw] md:ml-1 transition-all duration-1000 ${
            isVisible
              ? "opacity-100 translate-x-[2vw] w-[12vw] md:w-[6vw]"
              : "opacity-100 -translate-x-[2vw] w-0"
          }`}
        />
      </div>
    )
  );
};

Header.propTypes = {
  headingData: PropTypes.object,
};

export default Header;
